/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import React from "react";
import { Link } from "react-router";
import { Button, Stack, Typography } from "@mui/material";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import { getCaseLink } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type DivorcePlannerModalProps = {
  divorce: AbstractCase;
  open: boolean;
  onClose: () => void;
};
const DivorcePlannerModal = ({ divorce, open, onClose }: DivorcePlannerModalProps) => {
  const actions = (
    <Stack spacing={2} sx={{ alignItems: "center", width: "100%" }}>
      <Button component={Link} to={getCaseLink(divorce) + "/antrag"} fullWidth color={"primary"} variant={"contained"}>
        Angaben vervollständigen
      </Button>
      <LinkLegalbird to={getCaseLink(divorce)}>Zurück zum Fall</LinkLegalbird>
    </Stack>
  );

  return (
    <DialogModal open={open} onClose={onClose} title={"Jetzt Scheidungsplaner freischalten!"} actions={actions}>
      <Stack spacing={2}>
        <Typography variant={"body2"}>
          Nur bei Legalbird erhalten Sie einen interaktiven Scheidungsplaner mit allen Details zum Ablauf, Tipps und Checklisten - genau auf Ihre persönliche
          Situation ausgerichtet!
        </Typography>
        <Typography variant={"body2"}>Der Scheidungsplaner richtet sich an Sie persönlich und basiert daher auf den Angaben zu Ihrer Scheidung.</Typography>
        <Typography variant={"body2"}>
          <strong>
            Sobald Sie alle Angaben eingetragen {divorce.acquisitionPartner !== PARTNER_IRIS.ADVOCARD && "und die Vollmacht erteilt"} haben, erhalten Sie
            kostenlos Zugriff!
          </strong>
        </Typography>
      </Stack>
    </DialogModal>
  );
};

export default DivorcePlannerModal;
